import { render, staticRenderFns } from "./ProductionTraceability.vue?vue&type=template&id=22c23349&scoped=true"
import script from "./ProductionTraceability.vue?vue&type=script&lang=js"
export * from "./ProductionTraceability.vue?vue&type=script&lang=js"
import style0 from "./ProductionTraceability.vue?vue&type=style&index=0&id=22c23349&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c23349",
  null
  
)

export default component.exports